import { render, staticRenderFns } from "./ui-form.vue?vue&type=template&id=641e626e"
import script from "./ui-form.vue?vue&type=script&lang=js"
export * from "./ui-form.vue?vue&type=script&lang=js"
import style0 from "./ui-form.vue?vue&type=style&index=0&id=641e626e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports